<template>
  <div class="partner-container glassy-app">
    <v-layout row wrap>
      <v-flex lg12 md12 sm12 xs12>
        <!-- Partner Header Card -->
        <v-card flat class="glassy-card slide-in">
          <v-container>
            <div class="pull-right partner-actions">
              <v-btn :depressed="true"
                     color="warning"
                     @click="suspendAccount()"
                     v-if="singlePartner.status === 1"
                     class="glassy-btn-warning">
                <v-icon left small>mdi-pause</v-icon>
                Suspend ({{ suspend_count }})
              </v-btn>
              <v-btn :depressed="true"
                     color="secondary"
                     @click="activateAccount()"
                     v-if="singlePartner.status === 0"
                     class="glassy-btn-secondary">
                <v-icon left small>mdi-play</v-icon>
                Activate ({{ activate_count }})
              </v-btn>
              <v-btn :depressed="true" @click="editPartner()" class="glassy-btn-edit">
                <v-icon left small>mdi-pencil</v-icon>
                Edit
              </v-btn>
            </div>

            <div class="partner-header-content">
              <h1 class="partner-title earth-color">
                <b>{{ singlePartner.name.toUpperCase() }}</b>
                <span class="partner-type-badge">{{ singlePartner.partner_type[0].toUpperCase() }}</span>
              </h1>
            </div>

            <v-divider class="glassy-divider"></v-divider>

            <v-row class="partner-details-grid">
              <v-col cols="12" sm="6" md="4" lg="4" xl="3" v-for="(detail, index) in partnerDetails" :key="index">
                <div class="partner-detail-item">
                  <span class="detail-label">{{ detail.label }}</span>
                  <span class="detail-value">{{ detail.value }}</span>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="4" lg="4" xl="3">
                <div class="partner-detail-item">
                  <span class="detail-label">Created On</span>
                  <span class="detail-value">{{ formated_date_time(singlePartner.created_at) }}</span>
                  <span class="detail-sub" v-if="singlePartner.created_by">by {{ singlePartner.created_by }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="4" xl="3" v-if="singlePartner.updated_at !== null">
                <div class="partner-detail-item">
                  <span class="detail-label">Updated On</span>
                  <span class="detail-value">{{ formated_date_time(singlePartner.updated_at) }}</span>
                  <span class="detail-sub" v-if="singlePartner.updated_by">by {{ singlePartner.updated_by }}</span>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <br />

        <!-- Tabs Section -->
        <v-tabs v-model="active" light slider-color="primary" class="glassy-tabs slide-in-delayed">
          <v-tab key="bookings" class="tab-label">
            <v-icon left>mdi-book-open</v-icon>
            BOOKINGS
          </v-tab>
          <v-tab key="users" class="tab-label">
            <v-icon left>mdi-account-group</v-icon>
            USERS
          </v-tab>
          <v-tab key="destinations" class="tab-label">
            <v-icon left>mdi-map-marker</v-icon>
            DESTINATIONS
          </v-tab>

          <!-- Bookings Tab -->
          <v-tab-item key="bookings">
            <v-card flat class="glassy-tab-card">
              <v-card-title class="tab-card-header">
                <h4 class="tab-title earth-color">
                  <v-icon left color="primary">mdi-book-open</v-icon>
                  BOOKINGS
                </h4>
                <v-spacer></v-spacer>
                <v-text-field append-icon="mdi-magnify"
                              label="Search"
                              single-line
                              hide-details
                              v-model="bookings_search"
                              class="glassy-search"
                              outlined
                              dense></v-text-field>
              </v-card-title>

              <v-data-table :headers="columns"
                            :items="$filterPartnerBooking"
                            :search="bookings_search"
                            :loading="$loadingTrue"
                            :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
                            :disable-initial-sort="true"
                            class="glassy-table">
                <v-progress-linear slot="progress"
                                   color="primary"
                                   indeterminate></v-progress-linear>

                <template slot="items" slot-scope="props">
                  <td>
                    <router-link :to="{
                        name: 'Booking',
                        params: { booking_id: props.item.booking_public_id },
                      }"
                                 class="glassy-link">
                      <u>{{ props.item.booking_ref_code }}</u>
                    </router-link>
                  </td>
                  <td class="text-dark">{{ props.item.booking_done_by }}</td>
                  <td>{{ formated_date(props.item.created_at) }}</td>
                  <td>{{ formated_date(props.item.booking_check_in_date) }}</td>
                  <td>{{ formated_date(props.item.booking_check_out_date) }}</td>
                  <td class="text-center">
                    <span class="guest-badge">{{ props.item.guest_total }}</span>
                  </td>
                  <td>
                    <span :class="getStatusClass(props.item.booking_status)">
                      {{ props.item.booking_status }}
                    </span>
                  </td>
                  <td>
                    <v-btn :depressed="true"
                           small
                           @click="openBooking(props.item.booking_public_id)"
                           class="glassy-btn-view">
                      <v-icon small left>mdi-eye</v-icon>
                      View
                    </v-btn>
                  </td>
                </template>

                <v-alert slot="no-results"
                         :value="true"
                         color="error"
                         icon="mdi-alert-circle">
                  Your search for "{{ bookings_search }}" found no results.
                </v-alert>
              </v-data-table>

              <div class="tab-actions">
                <v-btn :depressed="true"
                       @click="getMore()"
                       color="info"
                       :loading="this.$store.state.LoadingStore.loading"
                       class="glassy-btn-info">
                  <v-icon left small>mdi-download</v-icon>
                  GET MORE
                </v-btn>
                <v-btn :depressed="true"
                       @click="getAllBookings()"
                       color="default"
                       :loading="this.$store.state.LoadingStore.loading"
                       class="glassy-btn-default">
                  <v-icon left small>mdi-format-list-bulleted</v-icon>
                  GET ALL
                </v-btn>
                <v-btn color="error"
                       :depressed="true"
                       @click="generateReportExcel()"
                       :loading="this.$store.state.LoadingStore.loading"
                       class="glassy-btn-error">
                  <v-icon left small>mdi-file-excel</v-icon>
                  GENERATE REPORT (EXCEL BETA)
                </v-btn>
                <v-btn color="warning"
                       :depressed="true"
                       @click="generateReportCSV()"
                       :loading="this.$store.state.LoadingStore.loading"
                       class="glassy-btn-warning">
                  <v-icon left small>mdi-file-delimited</v-icon>
                  GENERATE REPORT (CSV BETA)
                </v-btn>
              </div>
            </v-card>
          </v-tab-item>

          <!-- Users Tab -->
          <v-tab-item key="users">
            <v-card flat class="glassy-tab-card">
              <v-card-title class="tab-card-header">
                <h4 class="tab-title earth-color">
                  <v-icon left color="primary">mdi-account-group</v-icon>
                  USERS
                </h4>
                <v-spacer></v-spacer>
                <v-text-field append-icon="mdi-magnify"
                              label="Search"
                              single-line
                              hide-details
                              v-model="search"
                              class="glassy-search"
                              outlined
                              dense></v-text-field>
              </v-card-title>

              <v-data-table :headers="userColumns"
                            :items="partnerUsers"
                            :search="search"
                            :loading="$loadingTrue"
                            class="glassy-table">
                <v-progress-linear slot="progress"
                                   color="primary"
                                   indeterminate></v-progress-linear>

                <template slot="items" slot-scope="props">
                  <td>
                    <div class="user-name-cell">
                      <v-icon small class="user-icon">mdi-account</v-icon>
                      {{ props.item.full_name }}
                    </div>
                  </td>
                  <td>{{ props.item.phone_number }}</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ formated_date(props.item.registered_on) }}</td>
                </template>

                <v-alert slot="no-results"
                         :value="true"
                         color="error"
                         icon="mdi-alert-circle">
                  Your search for "{{ search }}" found no results.
                </v-alert>
              </v-data-table>
            </v-card>
          </v-tab-item>

          <!-- Destinations Tab -->
          <v-tab-item key="destinations">
            <v-card flat class="glassy-tab-card">
              <v-card-title class="tab-card-header">
                <h4 class="tab-title earth-color">
                  <v-icon left color="primary">mdi-map-marker</v-icon>
                  DESTINATIONS
                </h4>
                <v-spacer></v-spacer>
                <v-text-field append-icon="mdi-magnify"
                              label="Search"
                              single-line
                              hide-details
                              v-model="search"
                              class="glassy-search"
                              outlined
                              dense></v-text-field>
              </v-card-title>

              <v-data-table :headers="destinationColumns"
                            :items="allPartnerDestinations"
                            :search="search"
                            :loading="$loadingTrue"
                            class="glassy-table">
                <v-progress-linear slot="progress"
                                   color="primary"
                                   indeterminate></v-progress-linear>

                <template slot="items" slot-scope="props">
                  <td>
                    <div class="destination-cell">
                      <v-icon small class="destination-icon">mdi-map-marker</v-icon>
                      {{ props.item.destination_name }}
                    </div>
                  </td>
                </template>

                <v-alert slot="no-results"
                         :value="true"
                         color="error"
                         icon="mdi-alert-circle">
                  Your search for "{{ search }}" found no results.
                </v-alert>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        suspend_count: 3,
        activate_count: 3,
        search: "",
        bookings_search: "",
        page: 2,
        columns: [
          { text: "Ref", value: "booking_ref_code" },
          { text: "Client Name", value: "booking_done_by" },
          { text: "Created Date", value: "created_at" },
          { text: "Check In", value: "booking_check_in_date" },
          { text: "Check Out", value: "booking_check_out_date" },
          { text: "Guests", value: "guest_total" },
          { text: "Status", value: "booking_status" },
          { text: "Action", value: "" },
        ],
        userColumns: [
          { text: "Name", value: "full_name" },
          { text: "Phone Number", value: "phone_number" },
          { text: "Email", value: "email" },
          { text: "Added On", value: "registered_on" },
        ],
        destinationColumns: [
          { text: "Name", value: "destination_name" },
        ],
      };
    },
    computed: {
      partnerDetails() {
        if (!this.singlePartner || Object.keys(this.singlePartner).length === 0) return [];
        return [
          { label: "Customer Code (KES)", value: this.singlePartner.customer_code },
          { label: "Customer Code (USD)", value: this.singlePartner.customer_code_usd },
          { label: "Conservation Discount", value: this.singlePartner.conservation_fee_discount + " %" },
          { label: "Phone Number", value: this.singlePartner.tel },
          { label: "Email", value: this.singlePartner.email },
          { label: "KRA Pin Number", value: this.singlePartner.kra_pin_number },
        ];
      }
    },
    methods: {
      editPartner: function () {
        this.$router.push({
          name: "EditPartner",
          params: {
            partner_id: this.$route.params.partner_id,
          },
        });
      },
      openBooking: function (publicId) {
        this.$router.push({
          name: "Booking",
          params: {
            booking_id: publicId,
          },
        });
      },
      getMore() {
        this.loading = true;
        let data = {
          publicId: this.$route.params.partner_id,
          page: this.page,
        };
        if (this.page === 2) {
          this.$store.dispatch("get_partner_bookings_streaming", data);
          this.page = this.page + 1;
        } else {
          this.$store.dispatch("get_partner_bookings_streaming", data);
          this.page = this.page + 1;
        }
      },
      getAllBookings() {
        this.loading = true;
        let data = {
          publicId: this.$route.params.partner_id,
          page: 0,
        };
        this.$store.dispatch("get_partner_bookings_streaming", data);
      },
      generateReportCSV() {
        var idList = [];
        this.$filterPartnerBooking.map(function (booking) {
          idList.push(booking.booking_public_id);
        });
        var data = {
          booking_ids: idList,
          print_format: "CSV",
          session_id: localStorage.getItem("lkjhgfdsa"),
        };
        this.$store.dispatch("generate_formatted_csv", data);
      },
      generateReportExcel() {
        var idList = [];
        this.$filterPartnerBooking.map(function (booking) {
          idList.push(booking.booking_public_id);
        });
        var data = {
          booking_ids: idList,
          print_format: "xls",
          session_id: localStorage.getItem("lkjhgfdsa"),
        };
        this.$store.dispatch("generate_formatted_csv", data);
      },
      activateAccount: function () {
        if (this.activate_count > 0) {
          this.activate_count = this.activate_count - 1;
        } else {
          var data = {
            public_id: this.$route.params.partner_id,
            session_id: localStorage.getItem("lkjhgfdsa"),
          };
          this.$store.dispatch("activate_partner", data);
        }
      },
      suspendAccount: function () {
        if (this.suspend_count > 0) {
          this.suspend_count = this.suspend_count - 1;
        } else {
          var data = {
            public_id: this.$route.params.partner_id,
            session_id: localStorage.getItem("lkjhgfdsa"),
          };
          this.$store.dispatch("suspend_partner", data);
        }
      },
      getStatusClass(status) {
        const statusMap = {
          'Confirmed': 'status-confirmed',
          'Pending': 'status-pending',
          'Cancelled': 'status-cancelled',
          'Completed': 'status-completed'
        };
        return statusMap[status] || 'status-default';
      }
    },
    created() {
      this.$store.dispatch("get_partner_bookings", this.$route.params.partner_id);
      this.$store.dispatch("get_partner", this.$route.params.partner_id);
      this.$store.dispatch(
        "get_institution_users",
        this.$route.params.partner_id
      );
      this.$store.dispatch(
        "get_institution_destinations",
        this.$route.params.partner_id
      );
    },
  };
</script>

<style scoped>
  /* --- Global Layout --- */
  .glass-app {
    min-height: 100vh;
    background: #f0f2f5;
  }

  .partner-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 20px;
    background: radial-gradient(ellipse at 50% 50%, rgba(116, 165, 51, 0.06) 0%, rgba(240, 242, 245, 0.92) 100%), url('https://www.olpejetaconservancy.org/wp-content/uploads/2024/07/Cape-Buffalo-1-scaled.webp') no-repeat center center fixed;
    background-size: cover;
    min-height: 100vh;
  }

  /* --- Slide-in Animations --- */
  .slide-in {
    animation: slideUp 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
    opacity: 0;
    transform: translateY(40px);
  }

  .slide-in-delayed {
    animation: slideUp 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.15s forwards;
    opacity: 0;
    transform: translateY(30px);
  }

  @keyframes slideUp {
    0% {
      opacity: 0;
      transform: translateY(40px);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* --- Glassy Cards - More Transparent --- */
  .glassy-card {
    background: rgba(255, 255, 255, 0.06) !important;
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
    transition: all 0.4s ease;
    position: relative;
    z-index: 10;
    padding: 8px 0;
  }

    .glassy-card:hover {
      background: rgba(255, 255, 255, 0.12) !important;
      box-shadow: 0 12px 48px rgba(0, 0, 0, 0.08);
    }

  .glassy-tab-card {
    background: rgba(255, 255, 255, 0.05) !important;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
    padding: 16px;
  }

  /* --- Partner Header --- */
  .partner-header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 8px;
  }

  .partner-title {
    font-size: 32px;
    color: #1e2a3a;
    margin: 0;
    text-shadow: 0 2px 4px rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .partner-type-badge {
    display: inline-block;
    background: rgba(116, 165, 51, 0.15);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(116, 165, 51, 0.20);
    border-radius: 30px;
    padding: 2px 16px;
    font-size: 18px;
    font-weight: 600;
    color: #74a533;
  }

  .partner-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 12px;
  }

  /* --- Glassy Buttons - More Transparent --- */
  .glassy-btn-warning {
    background: rgba(255, 193, 7, 0.50) !important;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: #1e2a3a !important;
    border-radius: 60px;
    padding: 6px 20px;
    font-weight: 600;
    transition: all 0.25s ease;
    box-shadow: 0 4px 16px rgba(255, 193, 7, 0.08);
  }

    .glassy-btn-warning:hover {
      background: rgba(255, 193, 7, 0.75) !important;
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(255, 193, 7, 0.15);
    }

  .glassy-btn-secondary {
    background: rgba(108, 117, 125, 0.50) !important;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: white !important;
    border-radius: 60px;
    padding: 6px 20px;
    font-weight: 600;
    transition: all 0.25s ease;
    box-shadow: 0 4px 16px rgba(108, 117, 125, 0.08);
  }

    .glassy-btn-secondary:hover {
      background: rgba(108, 117, 125, 0.75) !important;
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(108, 117, 125, 0.15);
    }

  .glassy-btn-edit {
    background: rgba(33, 150, 243, 0.50) !important;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: white !important;
    border-radius: 60px;
    padding: 6px 20px;
    font-weight: 600;
    transition: all 0.25s ease;
    box-shadow: 0 4px 16px rgba(33, 150, 243, 0.08);
  }

    .glassy-btn-edit:hover {
      background: rgba(33, 150, 243, 0.75) !important;
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(33, 150, 243, 0.15);
    }

  .glassy-btn-info {
    background: rgba(33, 150, 243, 0.50) !important;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: white !important;
    border-radius: 60px;
    padding: 8px 24px;
    font-weight: 600;
    transition: all 0.25s ease;
    box-shadow: 0 4px 16px rgba(33, 150, 243, 0.08);
  }

    .glassy-btn-info:hover {
      background: rgba(33, 150, 243, 0.75) !important;
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(33, 150, 243, 0.15);
    }

  .glassy-btn-default {
    background: rgba(158, 158, 158, 0.40) !important;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: #1e2a3a !important;
    border-radius: 60px;
    padding: 8px 24px;
    font-weight: 600;
    transition: all 0.25s ease;
  }

    .glassy-btn-default:hover {
      background: rgba(158, 158, 158, 0.65) !important;
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    }

  .glassy-btn-error {
    background: rgba(244, 67, 54, 0.50) !important;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: white !important;
    border-radius: 60px;
    padding: 8px 24px;
    font-weight: 600;
    transition: all 0.25s ease;
    box-shadow: 0 4px 16px rgba(244, 67, 54, 0.08);
  }

    .glassy-btn-error:hover {
      background: rgba(244, 67, 54, 0.75) !important;
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(244, 67, 54, 0.15);
    }

  .glassy-btn-view {
    background: rgba(76, 175, 80, 0.40) !important;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.10);
    color: white !important;
    border-radius: 40px;
    padding: 4px 16px;
    font-weight: 500;
    transition: all 0.25s ease;
  }

    .glassy-btn-view:hover {
      background: rgba(76, 175, 80, 0.65) !important;
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(76, 175, 80, 0.12);
    }

  /* --- Divider --- */
  .glassy-divider {
    border-color: rgba(255, 255, 255, 0.12) !important;
    margin: 16px 0;
  }

  /* --- Partner Details Grid --- */
  .partner-details-grid {
    margin-bottom: 8px;
  }

  .partner-detail-item {
    display: flex;
    flex-direction: column;
    padding: 8px 0;
  }

  .detail-label {
    font-size: 11px;
    font-weight: 600;
    color: #4a5568;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    opacity: 0.7;
  }

  .detail-value {
    font-size: 16px;
    font-weight: 600;
    color: #1e2a3a;
    margin-top: 2px;
  }

  .detail-sub {
    font-size: 13px;
    color: #4a5568;
    margin-top: 2px;
    opacity: 0.7;
  }

  /* --- Tabs --- */
  .glassy-tabs {
    background: rgba(255, 255, 255, 0.05) !important;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
    overflow: hidden;
  }

  .tab-label {
    font-weight: 600;
    color: #1e2a3a !important;
    letter-spacing: 0.5px;
    font-size: 14px;
  }

    .tab-label .v-icon {
      color: #74a533 !important;
    }

  .tab-card-header {
    padding: 16px 8px !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.10);
  }

  .tab-title {
    font-size: 18px;
    color: #1e2a3a;
    font-weight: 600;
    display: flex;
    align-items: center;
    margin: 0;
  }

  /* --- Glassy Search - More Transparent --- */
  .glassy-search .v-input__slot {
    background: rgba(255, 255, 255, 0.10) !important;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 12px;
    transition: all 0.3s ease;
  }

    .glassy-search .v-input__slot:hover {
      background: rgba(255, 255, 255, 0.20) !important;
      border-color: rgba(255, 255, 255, 0.20);
    }

    .glassy-search .v-input__slot:focus-within {
      background: rgba(255, 255, 255, 0.30) !important;
      border-color: #74a533;
      box-shadow: 0 0 0 3px rgba(116, 165, 51, 0.06);
    }

  .glassy-search input {
    color: #1e2a3a !important;
  }

  .glassy-search .v-input__append-inner .v-icon {
    color: #4a5568 !important;
  }

  /* --- Glassy Table - More Transparent --- */
  .glassy-table {
    background: transparent !important;
  }

    .glassy-table > > > .v-data-table__wrapper {
      background: transparent !important;
    }

    .glassy-table > > > table {
      background: transparent !important;
    }

    .glassy-table > > > thead tr th {
      background: rgba(255, 255, 255, 0.08) !important;
      backdrop-filter: blur(4px);
      color: #1e2a3a !important;
      font-weight: 700 !important;
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      border-bottom: 2px solid rgba(255, 255, 255, 0.08);
    }

    .glassy-table > > > tbody tr {
      background: rgba(255, 255, 255, 0.04) !important;
      transition: all 0.2s ease;
    }

      .glassy-table > > > tbody tr:hover {
        background: rgba(255, 255, 255, 0.12) !important;
      }

    .glassy-table > > > tbody td {
      color: #1e2a3a !important;
      border-bottom: 1px solid rgba(255, 255, 255, 0.06);
      padding: 12px 16px;
    }

  /* --- Status Badges - More Transparent --- */
  .status-confirmed {
    background: rgba(76, 175, 80, 0.12);
    color: #2e7d32;
    padding: 2px 12px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 12px;
    border: 1px solid rgba(76, 175, 80, 0.15);
  }

  .status-pending {
    background: rgba(255, 193, 7, 0.12);
    color: #f57f17;
    padding: 2px 12px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 12px;
    border: 1px solid rgba(255, 193, 7, 0.15);
  }

  .status-cancelled {
    background: rgba(244, 67, 54, 0.12);
    color: #c62828;
    padding: 2px 12px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 12px;
    border: 1px solid rgba(244, 67, 54, 0.15);
  }

  .status-completed {
    background: rgba(33, 150, 243, 0.12);
    color: #0d47a1;
    padding: 2px 12px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 12px;
    border: 1px solid rgba(33, 150, 243, 0.15);
  }

  .status-default {
    background: rgba(158, 158, 158, 0.12);
    color: #424242;
    padding: 2px 12px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 12px;
    border: 1px solid rgba(158, 158, 158, 0.15);
  }

  /* --- Guest Badge --- */
  .guest-badge {
    display: inline-block;
    background: rgba(116, 165, 51, 0.10);
    color: #74a533;
    font-weight: 700;
    padding: 2px 12px;
    border-radius: 20px;
    border: 1px solid rgba(116, 165, 51, 0.10);
  }

  /* --- User Cell --- */
  .user-name-cell {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .user-icon {
    color: #74a533 !important;
  }

  /* --- Destination Cell --- */
  .destination-cell {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .destination-icon {
    color: #74a533 !important;
  }

  /* --- Tab Actions --- */
  .tab-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px 8px 8px;
    border-top: 1px solid rgba(255, 255, 255, 0.10);
    margin-top: 16px;
  }

  /* --- Glassy Link --- */
  .glassy-link {
    color: #1e2a3a !important;
    text-decoration: none;
    font-weight: 600;
    transition: all 0.2s ease;
  }

    .glassy-link:hover {
      color: #74a533 !important;
    }

    .glassy-link u {
      text-decoration-thickness: 2px;
    }

  /* --- Earth Color --- */
  .earth-color {
    color: #1e2a3a;
  }

  /* --- Responsive --- */
  @media (max-width: 960px) {
    .partner-container {
      padding: 16px;
    }

    .partner-title {
      font-size: 26px;
    }

    .partner-type-badge {
      font-size: 16px;
      padding: 2px 12px;
    }

    .partner-actions {
      justify-content: flex-start;
    }

    .detail-value {
      font-size: 14px;
    }

    .tab-title {
      font-size: 16px;
    }

    .tab-actions {
      flex-direction: column;
    }

      .tab-actions .v-btn {
        width: 100%;
        justify-content: center;
      }
  }

  @media (max-width: 600px) {
    .partner-container {
      padding: 10px;
    }

    .glassy-card {
      padding: 4px 0;
      border-radius: 16px;
    }

    .glassy-tab-card {
      padding: 8px;
      border-radius: 12px;
    }

    .partner-title {
      font-size: 20px;
    }

    .partner-type-badge {
      font-size: 13px;
      padding: 2px 10px;
    }

    .partner-actions {
      flex-direction: column;
      width: 100%;
    }

      .partner-actions .v-btn {
        width: 100%;
        justify-content: center;
      }

    .detail-value {
      font-size: 13px;
    }

    .tab-label {
      font-size: 12px;
      padding: 0 8px !important;
    }

    .tab-card-header {
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
    }

    .glassy-search {
      width: 100%;
    }

    .glassy-table > > > tbody td {
      padding: 8px 10px;
      font-size: 13px;
    }

    .status-confirmed,
    .status-pending,
    .status-cancelled,
    .status-completed,
    .status-default {
      font-size: 10px;
      padding: 1px 8px;
    }
  }

  /* --- Global Vuetify Overrides --- */
  .partner-container ::v-deep .v-application--wrap {
    background: transparent !important;
  }

  .partner-container ::v-deep .v-card__text {
    color: #1e2a3a !important;
  }

  .partner-container ::v-deep .v-tabs-bar {
    background: transparent !important;
  }

  .partner-container ::v-deep .v-tab {
    background: transparent !important;
  }

  .partner-container ::v-deep .v-tab--active {
    color: #74a533 !important;
  }

  .partner-container ::v-deep .v-slide-group__next,
  .partner-container ::v-deep .v-slide-group__prev {
    background: rgba(255, 255, 255, 0.15) !important;
    backdrop-filter: blur(4px);
    border-radius: 50%;
  }

  .partner-container ::v-deep .v-data-table__empty-wrapper {
    color: #1e2a3a !important;
  }

  .partner-container ::v-deep .v-progress-linear {
    background: rgba(255, 255, 255, 0.05) !important;
  }

  .partner-container ::v-deep .v-alert {
    background: rgba(244, 67, 54, 0.08) !important;
    backdrop-filter: blur(4px);
    border: 1px solid rgba(244, 67, 54, 0.10);
    color: #c62828 !important;
  }

    .partner-container ::v-deep .v-alert .v-icon {
      color: #c62828 !important;
    }
</style>
